//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import downloadImgs from '@/mixins/downloadImgs'
export default {
  mixins: [downloadImgs],
  data () {
    return {
      sortList: [...this.question.options],
      rule: {
        custom: {
          isSort: {
            required: () => '请排序',
          }
        }
      },
      isSort: ''
    }
  },
  components: {
    draggable
  },
  props: {
    question: {
      type: Object,
      default() {
        return {}
      }
    },
    index: {
      type: Number
    },
    readonly: {
      type: Boolean
    },
    showScore: {
      type: Boolean,
      default: false,
    },
  },
  mounted () {
    this.$validator.localize('zh_CN', this.rule);
    //已答的题挂上答案
    if (this.question.v_answer) {
      const sortOptions = this.question.v_answer.options || []
      let sortList = []
      sortOptions.forEach(element => {
        this.question.options.forEach((option, index) => {
          if (element.tenantId == option.tenantId) {
            sortList.push({
              text: option.text,
              tenantId: option.tenantId
            })
          }
        })  
      })
      this.sortList = sortList
    }
    console.log(this.question.v_answer);
  },
  computed: {
    ...mapGetters(['questionnaireList'])
  },
  watch: {
    async sortList (n ,o) {
      console.log(n);
      const param = {
        index: this.index,
        v_answered: !!n
      }
      let v_answer = {}
      // 设置当前题目已答
      this.$store.commit('setQuestionAnswered', param)
      if (!param.v_answered) {
        this.$store.commit('setQusstionUserAnswer', {
          index: this.index,
          v_answer
        })
        return
      }
      this.isSort = param.v_answered
      v_answer = this.getValue()
      console.log(v_answer);
      //挂本道题用户答案
      this.$store.commit('setQusstionUserAnswer', {
        index: this.index,
        v_answer
      })
    }
    
  },
  methods: {
    getValue (value) {
      let options = this.sortList.map(i=>{
				return {
          tenantId: i.tenantId
        }
			})
      return {
        tenantId: this.question.tenantId,
				type: 'sort',
				options: options
      }
    },
    validate () {
      return this.$validator.validateAll()
    },
  }
}
